import { push } from "connected-react-router";

import { checkAndRenewTokens, checkTokenError } from "./auth";
import { getQuestionsCount } from "../../request";

//Сообщения об ошибке, успехе, предупреждении
export const SHOW_ERROR_MSG = "Show error message";
export const HIDE_ERROR_MSG = "Hide error message";

export const SHOW_SUCCESS_MSG = "Show success message";
export const HIDE_SUCCESS_MSG = "Hide success message";

export const SHOW_WARNING_MSG = "Show warning message";
export const HIDE_WARNING_MSG = "Hide warning message";

//Окно отмены создания или редактирования опроса
export const OPEN_CANCEL_MODAL = "Open cancel modal";
export const CLOSE_CANCEL_MODAL ="Close cancel modal";

//Окно ввода кода подтверждения телефона для авторизации
export const OPEN_AUTH_PHONE_MODAL = "Open authorization phone modal";
export const CLOSE_AUTH_PHONE_MODAL ="Close authorization phone modal";

//Окно подтверждения удаления шаблона
export const OPEN_DELETE_TEMPLATE_MODAL = "Open delete template modal";
export const CLOSE_DELETE_TEMPLATE_MODAL = "Close delete template modal";

//Окно подтверждения удаления сообщения
export const OPEN_DELETE_MESSAGE_MODAL = "Open delete message modal";
export const CLOSE_DELETE_MESSAGE_MODAL = "Close delete message modal";

//Окно подтверждения удаления вопроса поддержки
export const OPEN_DELETE_QUESTION_MODAL = "Open delete question modal";
export const CLOSE_DELETE_QUESTION_MODAL = "Close delete question modal";

//Окно подтверждения изменения локализации
export const OPEN_CHANGE_LOCALE_MODAL = "Open change locale modal";
export const CLOSE_CHANGE_LOCALE_MODAL = "Close change locale modal";

//Окно отмены изменения локализации
export const OPEN_CANCEL_CHANGE_LOCALE_MODAL = "Open cancel change locale modal";
export const CLOSE_CANCEL_CHANGE_LOCALE_MODAL = "Close cancel change locale modal";

//Окно фильтрации
export const OPEN_FILTERS_MODAL = "Open filters modal";
export const CLOSE_FILTERS_MODAL = "Close filters modal";

//Сайдбар
export const TOGGLE_MENU_HELPER = "Toggle sidebar menu helper";

//Получение количества вопросов для клиентов и консультантов
export const QUESTIONS_COUNT_LOADING_START = "Questions count loading started";
export const QUESTIONS_COUNT_LOADED_SUCCESSFULLY = "Questions count loaded successfully";
export const QUESTIONS_COUNT_LOADING_FAILED = "Failure during questions count loading";

//Сайдбар
export const toggleMenuHelper = () => ({
  type: TOGGLE_MENU_HELPER,
});

//Сообщения об ошибке, успехе, предупреждении
//Ошибка
export const showErrorMessage = text => ({
  type: SHOW_ERROR_MSG,
  payload: { text }
});

export const hideErrorMessage = () => ({
  type: HIDE_ERROR_MSG,
});

//Успех
export const showSuccessMessage = text => ({
  type: SHOW_SUCCESS_MSG,
  payload: { text }
});

export const hideSuccessMessage = () => ({
  type: HIDE_SUCCESS_MSG,
});

//Предупреждение
export const showWarningMessage = text => ({
  type: SHOW_WARNING_MSG,
  payload: { text }
});

export const hideWarningMessage = () => ({
  type: HIDE_WARNING_MSG,
});

//Окно отмены создания или редактирования опроса
export const openCancelModal = () => ({
  type: OPEN_CANCEL_MODAL,
});

export const closeCancelModal = () => ({
  type: CLOSE_CANCEL_MODAL,
});

//Окно ввода кода подтверждения телефона для авторизации
export const openAuthPhoneModal = () => ({
  type: OPEN_AUTH_PHONE_MODAL,
});

export const closeAuthPhoneModal = () => ({
  type: CLOSE_AUTH_PHONE_MODAL,
});

//Окно подтверждения удаления шаблона
export const openDeleteTemplateModal = () => ({
  type: OPEN_DELETE_TEMPLATE_MODAL,
});

export const closeDeleteTemplateModal = () => ({
  type: CLOSE_DELETE_TEMPLATE_MODAL,
});

//Окно подтверждения удаления сообщения
export const openDeleteMessageModal = () => ({
  type: OPEN_DELETE_MESSAGE_MODAL,
});

export const closeDeleteMessageModal = () => ({
  type: CLOSE_DELETE_MESSAGE_MODAL,
});

//Окно подтверждения удаления вопроса поддержки
export const openDeleteQuestionModal = () => ({
  type: OPEN_DELETE_QUESTION_MODAL,
});

export const closeDeleteQuestionModal = () => ({
  type: CLOSE_DELETE_QUESTION_MODAL,
});

//Окно подтверждения изменения локализации
export const openChangeLocaleModal = () => ({
  type: OPEN_CHANGE_LOCALE_MODAL,
});

export const closeChangeLocaleModal = () => ({
  type: CLOSE_CHANGE_LOCALE_MODAL,
});

//Окно отмены изменения локализации
export const openCancelChangeLocaleModal = () => ({
  type: OPEN_CANCEL_CHANGE_LOCALE_MODAL,
});

export const closeCancelChangeLocaleModal = () => ({
  type: CLOSE_CANCEL_CHANGE_LOCALE_MODAL,
});

//Окно фильтрации
export const openFiltersModal = () => ({
  type: OPEN_FILTERS_MODAL,
});

export const closeFiltersModal = () => ({
  type: CLOSE_FILTERS_MODAL,
});

//ПОЛУЧЕНИЕ КОЛИЧЕСТВА ВОПРОСОВ ДЛЯ КЛИЕНТОВ И КОНСУЛЬТАНТОВ
const startCountLoading = () => ({
  type: QUESTIONS_COUNT_LOADING_START
});

const countLoadingSuccess = (forClients, forConsultants) => ({
  type: QUESTIONS_COUNT_LOADED_SUCCESSFULLY,
  payload: { forClients, forConsultants },
});

const countLoadingFailure = () => ({
  type: QUESTIONS_COUNT_LOADING_FAILED,
});

export const getQuestionsCountAsync = () => {
  return async (dispatch) => {
    dispatch(startCountLoading());
    await dispatch(checkAndRenewTokens());
    let questionsCount;
    try {
      const accessToken = localStorage.getItem("accessToken");
      questionsCount = await getQuestionsCount(accessToken);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при получении количества вопросов'));
      return dispatch(countLoadingFailure());
    }
    //Разбор полученного массива
    const forClients = questionsCount.client_count;
    const forConsultants = questionsCount.consultant_count;
    //Если и тех и других есть по 5, возвращаем пользователя на список сообщений
    if ((forClients >= 5) && (forConsultants >= 5)) dispatch(push('/questions'));
    return dispatch(countLoadingSuccess(forClients, forConsultants));
  };
};
